import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const GoogleIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.152 6.56v2.623h4.34c-.174 1.125-1.311 3.302-4.34 3.302-2.612 0-4.744-2.164-4.744-4.832 0-2.668 2.132-4.833 4.745-4.833 1.486 0 2.481.635 3.05 1.181l2.077-2C11.946.754 10.219 0 8.153 0A7.647 7.647 0 0 0 .5 7.652a7.647 7.647 0 0 0 7.652 7.653c4.417 0 7.348-3.105 7.348-7.478a7.04 7.04 0 0 0-.121-1.268H8.153Z"
                fill={color}
            />
        </svg>
    );
};

export default React.memo(GoogleIcon);
